import { Icon } from "framework7-react";

const blurOnEnter = (event) => {
  if (event.key === "Enter") event.currentTarget.blur();
};

const ExpenseSearch = ({ value, onChange }) => (
  <div className="expense-search">
    <Icon
      className="expense-search-icon"
      ios="f7:search"
      md="material:search"
    />
    <input
      type="search"
      className="expense-search-input"
      placeholder="Titel, Person, Tag oder Betrag"
      aria-label="Ausgaben durchsuchen"
      autoComplete="off"
      autoCorrect="off"
      spellCheck={false}
      enterKeyHint="search"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={blurOnEnter}
    />
    {value && (
      <button
        type="button"
        className="expense-search-clear"
        aria-label="Suche leeren"
        onClick={() => onChange("")}
      >
        <Icon ios="f7:xmark_circle_fill" md="material:cancel" />
      </button>
    )}
  </div>
);

export default ExpenseSearch;
